import React, { useEffect } from "react";
import { SlovHeader } from "./cardsHeader";

export const CardsCategoriesScreen = (props) => {
    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    const buttonStyle = {
        width: "80%",
        padding: "15px",
        marginBottom: "12px",
        fontSize: "16px",
    };

    return (
        <div id="game">
            <SlovHeader />

            <img
                src={props.PColors !== undefined ? "https://cyberbox.trgu.ru/public/avatars/cards/PlayerMain" + (props.PColors + 1) + ".png" : "Аватар загружается\n"}
                alt="Player Avatar"
            />
            <br />
            <div className="divtext_slov"><b>{props.prName}</b></div>
            <br />
            <div className="divtext_slov"><b>{props.slovGamePoints}</b> очков</div>
            <br />

            <div className="divtext_slov"><b>Выберите повод</b></div>
            <br />

            <button type="button" style={buttonStyle} onClick={() => props.sendMessage("sendtoserver|slov\\buttonchosen\\povod\\1")}>
                {props.TextString}
            </button>
            <br />

            <button type="button" style={buttonStyle} onClick={() => props.sendMessage("sendtoserver|slov\\buttonchosen\\povod\\2")}>
                {props.TextString2}
            </button>
            <br />

            <button type="button" style={buttonStyle} onClick={() => props.sendMessage("sendtoserver|slov\\buttonchosen\\povod\\3")}>
                {props.TextString3}
            </button>
        </div>
    );
};